import styled from "styled-components";

export const StarImgContainer = styled.img`
    width: 80%;
    height: 100%;
`
export const DetailRowImage = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
`